/**
 * @name libraries
 * @description
 */
export default class Utils {

    constructor() {}

    /**
     * @name replaceAll
     * @description
     * Funtion to replace content into the string
     */
    replaceAll(str, searchStr, replaceStr) {
        // escape regexp special characters in search string
        searchStr = searchStr.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

        return str.replace(new RegExp(searchStr, 'gi'), replaceStr);
    }
}